import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {Box} from '@primer/react'
import React from 'react'

export const LoadingContentBlock = React.memo(LoadingContentBlockUnmemoized)

//using boxes specifically because they provide some styling stuff that makes the skeleton look nicer
function LoadingContentBlockUnmemoized() {
  return (
    <Box
      sx={{
        paddingTop: 3,
        gap: 2,
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box sx={{gap: 2}}>
        <Box sx={{borderRadius: 2, border: '1px solid', borderColor: 'border.subtle'}}>
          <Box
            sx={{
              alignItems: 'center',
              gap: 2,
              padding: 3,
              borderBottom: '1px solid',
              borderBottomColor: 'border.subtle',
              backgroundColor: 'canvas.subtle',
              borderTopLeftRadius: 2,
              borderTopRightRadius: 2,
            }}
          >
            <LoadingSkeleton height="sm" variant="rounded" width="140px" />
          </Box>
          <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, padding: 3}}>
            <LoadingSkeleton height="sm" variant="rounded" width="random" />
            <LoadingSkeleton height="sm" variant="rounded" width="random" />
            <LoadingSkeleton height="sm" variant="rounded" width="random" />
            <LoadingSkeleton height="sm" variant="rounded" width="random" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

try{ LoadingContentBlock.displayName ||= 'LoadingContentBlock' } catch {}
try{ LoadingContentBlockUnmemoized.displayName ||= 'LoadingContentBlockUnmemoized' } catch {}